import LZString from 'lz-string';

export default {

    set(key, value) {
        const json = JSON.stringify(value);
        const bytes = new Blob([json]).size;

        if (bytes > 4.5 * 1024 * 1024) {
            const compressed = LZString.compressToBase64(json);

            localStorage.setItem(key, '@@@' + compressed);
        } else {
            localStorage.setItem(key, json);
        }
    },

    get(key) {
      const value = localStorage.getItem(key);

      if (!value) {
          return null;
      }

      let json;

      if (value.startsWith('@@@')) {
          json = LZString.decompressFromBase64(value.substring(3));
      } else {
          json = value;
      }

      if (!json) {
          return null;
      }

      return JSON.parse(json);
  },

  remove(key) {
    localStorage.removeItem(key);
  },

};